import TextField from '@mui/material/TextField';

export default function ReservationHeader({
    onAddReservation,
    selectedDate,
    onDateChange
})   {
    return (
        <>
            <div id="titleContainer">
                <button className="add-button" onClick={onAddReservation}>
                    Add Reservation
                </button>
                <h1 style={{margin:'5px'}}>Reservation</h1>
                <TextField
                    label="Reservation Date"
                    name="Reservation Date"
                    type="date"
                    value={selectedDate}
                    onChange={onDateChange}
                    fullWidth
                    sx={{ width: '150px', height: '40px', margin: '15px' }}
                />
            </div>
            <hr />
        </>
    );
}
